import { reactive } from 'vue'
const GlobalVars= reactive({});

export default GlobalVars;
